export const contractDetailsModalStyles = {
  container: {
    minHeight: '400px',
    maxHeight: '80vh',
    overflowY: 'auto',
  },

  statusSection: {
    p: 3,
    borderRadius: 2,
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    mb: 3,
  },

  sectionTitle: {
    fontWeight: 600,
    mb: 2,
    color: 'text.primary',
  },

  statusChip: {
    fontWeight: 600,
    fontSize: '0.875rem',
    minWidth: '120px',
  },

  divider: {
    my: 3,
    borderColor: 'divider',
  },

  infoSection: {
    mb: 3,
  },

  infoItem: {
    display: 'flex',
    alignItems: 'flex-start',
    p: 2.5,
    borderRadius: 2,
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    transition: 'all 0.2s ease-in-out',
    height: '100%',
    '&:hover': {
      bgcolor: 'action.hover',
      borderColor: 'primary.main',
      transform: 'translateY(-1px)',
      boxShadow: (theme) =>
        theme.palette.mode === 'dark'
          ? '0 4px 12px rgba(0, 0, 0, 0.3)'
          : '0 4px 12px rgba(0, 0, 0, 0.1)',
    },
  },

  infoIcon: {
    mr: 2,
    mt: 0.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    borderRadius: '50%',
    bgcolor: 'primary.main',
    color: 'primary.contrastText',
    flexShrink: 0,
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
    },
    '& .MuiSvgIcon-root.MuiSvgIcon-colorPrimary': {
      color: 'primary.contrastText',
    },
  },

  infoContent: {
    flex: 1,
    minWidth: 0,
  },

  infoLabel: {
    display: 'block',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    mb: 0.5,
    fontSize: '0.75rem',
  },

  infoValue: {
    display: 'block',
    fontWeight: 600,
    wordBreak: 'break-word',
    fontSize: '0.875rem',
  },

  commentSection: {
    p: 3,
    borderRadius: 2,
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    minHeight: '80px',
  },
};
